import React, { Component, PropTypes } from 'react'
import Modal from './modal'
import Menu from './menu'
import { AUTH_EXEMPT_VIEWS } from '../constants/authExempt'

import AuthWrapper from './account/auth_wrapper'

export { AuthWrapper }

export SignUp from './account/sign_up'
export SignIn from './account/sign_in'
export SignOut from './account/sign_out'
export ForgotPassword from './account/forgot_password'
export ResetPassword from './account/reset_password'
export Activate from './account/activate'

export default class Account extends Component {
    static propTypes = {
        account: PropTypes.shape({
            user: PropTypes.object,
        }).isRequired,
        children: PropTypes.node,
        crew: PropTypes.object,
        modal: PropTypes.shape({
            component: PropTypes.object,
            modalProps: PropTypes.object,
        }),
        modalActions: PropTypes.shape({
            hideModal: PropTypes.func.isRequired,
        }).isRequired,
        personal: PropTypes.object,
        personalActions: PropTypes.object,
        router: PropTypes.object,
    }

    renderChildren() {
        return React.Children.map(
            this.props.children,
            (child) => React.cloneElement(child, this.props)
        )
    }

    render() {
        // Insert the menu if the user is authenticated
        let menu = null

        if (this.props.account.user) {
            menu = (
                <Menu
                    account={ this.props.account }
                    crew={ this.props.crew }
                    personal={ this.props.personal }
                    personalActions={ this.props.personalActions }
                    router={ this.props.router }
                />
            )
        }

        let component = null
        let modalProps = {
            allowClose: true,
            title: '',
            onClose: () => { this.props.modalActions.hideModal() },
        }

        if (this.props.modal && this.props.modal.component) {
            component = this.props.modal.component

            modalProps = {
                ...modalProps,
                open: true,
                ...(this.props.modal.modalProps || {}),
            }
        }

        const modal = (
            <Modal { ...modalProps }>
                { component }
            </Modal>
        )

        // Check if the child component needs authentication
        const cmpt_name = this.props.children.type.displayName

        if (AUTH_EXEMPT_VIEWS.indexOf(cmpt_name) === -1) {
            return (
                <AuthWrapper { ...this.props }>
                    { menu }
                    { this.props.children }
                    { modal }
                </AuthWrapper>
            )
        }

        return <div>{ this.renderChildren() }</div>
    }
}



// WEBPACK FOOTER //
// ./app/components/account.js